import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import Loading from '../components/psc/lib/Loading'

const SharepointCallback = () => {
    const location = useLocation()
    const navigate = useNavigate()
    
    useEffect(() => {
        const query = new URLSearchParams(location.search)
        const code = query.get('code')
        const state = query.get('state')
        const url = "/v0/sharepoint/token/callback?code="+code+"&state="+state
        fetch(url, { credentials: 'same-origin' })
            .then(function(response) {
                if (!response.ok) throw response
                return response.json()
            })
            .then(function(json) {
                navigate(json.redirect_url)
            })
            .catch(error => console.log("OAuth callback error", error))
        
    }, [])
    return <Loading />
};

export default SharepointCallback
